import { render, staticRenderFns } from "./NavDrawerUser.vue?vue&type=template&id=47633aec&"
import script from "./NavDrawerUser.vue?vue&type=script&lang=js&"
export * from "./NavDrawerUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports